/**
 * KAN-759: модалки заказов на доске CRM. Клик по оформленному заказу:
 * просмотр; клик по текущей корзине: формирование; "Новый заказ" (KAN-780:
 * кнопка-иконка в ячейке действий):
 * черновик клиента (POST /api/v1/orders/ {client_id}, backend вернёт
 * текущий черновик, если он есть) и сразу формирование.
 */
import { useState } from 'react';
import { toast } from 'sonner';
import { useCreateOrder } from '@/hooks/useOrders';
import { extractErrorMessage } from '@/lib/extractErrorMessage';

export interface CrmOrderDialogs {
  viewOrderId: string | null;
  composeOrderId: string | null;
  openView: (orderId: string) => void;
  openCompose: (orderId: string) => void;
  closeView: () => void;
  closeCompose: () => void;
  startOrder: (clientId: string) => void;
  /** Клиент, для которого сейчас создаётся черновик. */
  creatingFor: string | null;
}

export function useCrmOrderDialogs(): CrmOrderDialogs {
  const [viewOrderId, setViewOrderId] = useState<string | null>(null);
  const [composeOrderId, setComposeOrderId] = useState<string | null>(null);
  const create = useCreateOrder();

  return {
    viewOrderId,
    composeOrderId,
    openView: setViewOrderId,
    openCompose: setComposeOrderId,
    closeView: () => setViewOrderId(null),
    closeCompose: () => setComposeOrderId(null),
    startOrder: (clientId) =>
      create.mutate(clientId, {
        onSuccess: (order) => setComposeOrderId(order.id),
        onError: (error) => toast.error(extractErrorMessage(error, 'Не удалось создать заказ')),
      }),
    creatingFor: create.isPending ? create.variables ?? null : null,
  };
}
